<template>
  <div
    id="ssr-page"
    class="ssr-page"
    :class="[lang, { 'transparent-bg-mode': isTransparentBgMode }]"
  >
    <transition :name="transitionName">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  UPDATE_THEME_CONFIG,
  LOAD_VN_REDIRECT_URL
} from '@store/officialStore/index';
import transparentBg from '@mixins/officialStore/transparentBg';
const changeTheme = gameCode => {
  document.documentElement.classList.add(gameCode);
  document.body.classList.add(gameCode);
};
export default {
  mixins: [transparentBg],
  data() {
    return {
      transitionName: ''
    };
  },
  computed: {
    gameId() {
      return this.$store.state.gameId;
    },
    lang() {
      return this.$store.state.lang;
    }
  },
  watch: {
    gameId: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          return;
        }
        globalConfig.setPageTitleAndIco(
          this.$store.getters.gameInfoConfig.pageTitle,
          this.$store.getters.gameInfoConfig.pageIco
        );
        this.$store.getters.gameInfoConfig?.appleTouchIcon &&
          globalConfig.addAppleTouchIcon(
            this.$store.getters.gameInfoConfig?.appleTouchIcon
          );
        changeTheme(this.$store.getters.gameInfoConfig.gameCode);
        globalConfig.getHrefParam('themeConfig') == 1 &&
          this.$store.commit(UPDATE_THEME_CONFIG, true);
      }
    }
  },
  beforeCreate() {
    // 2024.1.4 需求人：邓智轩 判断越南ip跳转到合作商页面处理 263:蚂蚁军团_全球版 288:蚂蚁军团_越南版
    // 2025.2.7 需求人：李紫健2号 越南KOC推广游戏的第三方支付页 判断链接参数cid=koc不跳转处理
    if (
      [263, 288].includes(+this.$store.state.gameId) &&
      globalConfig.getHrefParam('cid') !== 'koc'
    ) {
      this.$store.dispatch(LOAD_VN_REDIRECT_URL).then(async res => {
        const vnRedirectUrl = res?.data?.url || '';
        if (vnRedirectUrl) {
          window.location.href = vnRedirectUrl;
        }
      });
    }
    const preLanguage = globalConfig.getHrefParamUndecode('language');
    if (preLanguage) {
      globalConfig.setLclStorageItem(
        globalConfig.getPageLangStorageKey(),
        preLanguage
      );
    }
    globalConfig.setRouterQuery(this.$route.query);
    globalConfig.setRoute(this.$route);
    globalConfig.init();
  },
  mounted() {
    if (
      globalConfig.getHrefParam('h5') == 1 &&
      globalConfig.getHrefParam('m') == 1
    ) {
      try {
        // 移动端双击禁止：主要是为了禁止放大
        document.addEventListener('dblclick', function (event) {
          event.preventDefault();
        });

        document
          .getElementById('ssr-page')
          .addEventListener('touchmove', function (e) {
            e.stopPropagation();
            e.preventDefault();
          });

        // 移动端快速点击禁止：主要是为了禁止放大
        let lastTouchEnd = 0;
        document.addEventListener(
          'touchend',
          function (event) {
            let now = new Date().getTime();
            if (now - lastTouchEnd <= 300) {
              event.preventDefault();
            }
            lastTouchEnd = now;
          },
          false
        );
      } catch (e) {}
    }
  }
};
</script>
<style>
html {
  width: 100%;
  height: 100%;
}
body {
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: var(--page-bg) !important;
}
.ssr-page {
  width: 750px;
  height: 100%;
  background-color: var(--page-bg);
  font-size: 0;
}
@media screen and (orientation: landscape) {
  .ssr-page {
    width: 100%;
  }
}
</style>
<style lang="scss">
@import '@assets/scss/officialStore/base.scss';
@import '@assets/scss/officialStore/config.scss';
@import '@assets/scss/officialStore/animate.scss';
@import '@assets/scss/officialStore/common.scss';
@import '@assets/scss/officialWebStore/font/iconfont.scss';
@media screen and (orientation: landscape) {
  @supports (zoom: 70%) {
    body {
      zoom: 70%;
    }
    #airwalletbtn {
      zoom: 150%;
      &.btn-container {
        transform: none;
      }
    }
  }
}
#ssr-page.transparent-bg-mode {
  background-color: transparent !important;
  overflow-y: hidden;
}
</style>
